<template>
  <router-view />
</template>

<script>
export default {
  name: "app-item"
};
</script>

<style lang="scss" scoped></style>
